<div cdkTrapFocus>
  <div class="modal-header">
    <h3 class="modal-title">
      <span i18n="@@boltAdditionalInformation">Additional Information</span>
    </h3>
    <button type="button" class="close" aria-label="Close" ngbAutoFocus (click)="modal.close()">
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body">
    @if (termsAndCond.length) {
    <ul class="modal-list">
      @for (rule of termsAndCond; track rule) {
      <li class="modal-list-item">
        <span
          class="rule-title"
          [ngClass]="{'note-message': rule.name?.toLowerCase() === 'cancellation'}"
          >{{rule.name | titlecase}}</span
        >
        <span class="rule-value">
          @if (isObject | memoize:rule.value) {
          <div>
            @for (item of value; track item) {
            <li>
              <strong>{{ item.name }}</strong>
              <span>{{ item.remark }}</span>
            </li>
            }
          </div>
          } @else {
          <span
            class="rule-value"
            [ngClass]="{'note-message': rule.name?.toLowerCase() === 'cancellation'}"
            [innerHTML]="rule.value"
          ></span>
          }
        </span>
      </li>
      }
    </ul>
    } @else { @if (loadingFareRules) {
    <div>Loading...</div>
    } @if (!loadingFareRules) {
    <span i18n="@@TermsAndConditionsNoData">No data to display</span>
    } }
  </div>
  <div class="modal-footer">
    <button
      type="button"
      appButton="small"
      class="small-button--no"
      i18n="@@fareruleOK"
      (click)="modal.close()"
    >
      Ok
    </button>
  </div>
</div>
